
import { TablePage, MemberList } from 'web-mojo';
import MemberView from './MemberView.js';

export default class MembersPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Members',
            pageName: 'members_page',
            icon: "bi-people-fill",
            route: "group/members",
            Collection: MemberList,
            permissions: ["view_members", "manage_group", "manage_users"],
            requiresGroup: true,

            viewDialogOptions: { header: false },

            defaultQuery: {
                sort: '-id',
                is_active: true
            },

            // Column definitions
            columns: [
                {
                    label: 'Avatar',
                    key: 'user.avatar|avatar("sm")',
                    sortable: false
                },
                {
                    key: 'user.display_name',
                    label: 'User',
                    formatter: "default('Not Set')"
                },
                {
                    key: 'user.email',
                    label: 'Email',
                    formatter: "default('No Email')"
                },
                {
                    key: 'is_active',
                    label: 'Is Active',
                    formatter: "badge",
                    filter: {
                        type: 'select',
                        options: [
                            { value: true, label: 'Active' },
                            { value: false, label: 'Inactive' }
                        ]
                    }
                },
                {
                    key: 'created',
                    label: 'Added',
                    formatter: "epoch|datetime"
                }
            ],

            // Empty state
            emptyMessage: 'No members found.',

            batchBarLocation: 'top',
            batchActions: [
                {
                    icon: 'bi-x-circle',
                    action: 'disable-users',
                    label: "Disable Users",
                    handler: async (items, event, el) => {
                        console.log("ADMIN CLICKED", items, this)
                    }
                }
            ],

            // Table display options (for HTML table styling)
            tableOptions: {
                striped: true,
                bordered: false,
                hover: true,
                responsive: false
            },

            tableViewOptions: {
                hideActivePillNames: ["group"],
                addButtonLabel: "Invite",
                onAdd: async (event) => {
                    this.onInviteClick(event);
                }
            },

            ...options,
        });
    }

    async onInviteClick(event) {
        event.preventDefault();
        const app = this.getApp();
        const data = await app.showForm({
            title: "Invite User To " + app.activeGroup.get("name"),
            fields: [
                {
                    type: 'email',
                    name: 'email',
                    label: 'Email',
                    required: true,
                    columns: 12
                }
            ]
        });

        if (data && data.email) {
            app.showLoading();
            const resp = await app.rest.POST('/api/group/member/invite', {
                group: app.activeGroup.id,
                email: data.email
            });
            app.hideLoading();
            if (resp.success) {
                app.toast.success("User invited successfully");
                this.collection.fetch();
            } else {
                app.toast.error("Failed to invite user");
            }
        }
    }
}
